
import { MHRecordingConstants } from '../base/lib-meet-hour';


/**
 * The identifier of the sound to be played when a live streaming session is stopped.
 *
 * @type {string}
 */
export const LIVE_STREAMING_OFF_SOUND_ID = 'LIVE_STREAMING_OFF_SOUND';

/**
 * The identifier of the sound to be played when a live streaming session is started.
 *
 * @type {string}
 */
export const LIVE_STREAMING_ON_SOUND_ID = 'LIVE_STREAMING_ON_SOUND';

/**
 * The identifier of the sound to be played when a recording session is stopped.
 *
 * @type {string}
 */
export const RECORDING_OFF_SOUND_ID = 'RECORDING_OFF_SOUND';

/**
 * The identifier of the sound to be played when a recording session is started.
 *
 * @type {string}
 */
export const RECORDING_ON_SOUND_ID = 'RECORDING_ON_SOUND';

/**
 * Expected supported recording types.
 *
 * @enum {string}
 */
export const RECORDING_TYPES = {
    MH_REC_SERVICE: 'recording-service',
    DROPBOX: 'dropbox',
    ONEDRIVE: 'onedrive',
    CUSTOM_S3: 'custom-s3'
};

const CUSTOM_S3_STORAGE_TYPES = new Set([
    'custom',
    'custom s3',
    'customs3',
    'awss3',
    'aws s3',
    's3'
]);

/**
 * Checks whether a storage label represents custom S3 storage.
 *
 * @param {?string} storageType - Storage label from the backend.
 * @returns {boolean}
 */
export function isCustomS3RecordingStorage(storageType: ?string) {
    if (typeof storageType !== 'string') {
        return false;
    }

    return CUSTOM_S3_STORAGE_TYPES.has(storageType.trim().toLowerCase());
}

/**
 * Checks whether a storage label represents Meet Hour local storage.
 *
 * @param {?string} storageType - Storage label from the backend.
 * @returns {boolean}
 */
export function isLocalRecordingStorage(storageType: ?string) {
    if (typeof storageType !== 'string') {
        return false;
    }

    return storageType.trim().toLowerCase() === 'local';
}

/**
 * An array defining the priorities of the recording (or live streaming)
 * statuses, where the index of the array is the priority itself.
 *
 * @type {Array<string>}
 */
export const RECORDING_STATUS_PRIORITIES = [
    MHRecordingConstants.status.OFF,
    MHRecordingConstants.status.PENDING,
    MHRecordingConstants.status.ON
];


export const LIVESTREAM_TOOLS = [
    {
        enabled: true,
        Facebook: {
            apiLogin: false,
            enabled: true


        },

        icon: 'IconFacebook',
        title: 'Facebook',
        toggle: false


    },
    {
        enabled: true,
        icon: 'IconYoutube',
        title: 'Youtube',
        toggle: false,
        YouTube: {
            apiLogin: false,
            enabled: true
        }
    },
    {
        enabled: true,
        icon: 'IconTwitch',
        title: 'Twitch',
        toggle: false,
        Twitch: {
            apiLogin: false,
            enabled: true

        }
    },
    {
        enabled: true,
        icon: 'IconLinkedin',
        LinkedIn: {
            apiLogin: false,
            enabled: true

        },
        title: 'LinkedIn',
        toggle: false
    },
    {
        enabled: true,
        icon: 'IconInstagram',
        Instagram: {
            apiLogin: false,
            enabled: true
        },
        title: 'Instagram',
        toggle: false


    },
    {
        CustomRtmp: {
            apiLogin: false,
            enabled: true
        },

        enabled: true,
        icon: 'IconCustom',
        title: 'Custom RTMP',
        toggle: false


    },
    {
        CustomRtmps: {
            apiLogin: false,
            enabled: true
        },
        enabled: true,
        icon: 'IconCustom',
        title: 'Custom RTMPS',
        toggle: false


    },
    {
        enabled: true,
        icon: 'IconVimeo',
        title: 'Vimeo',
        toggle: false,
        Vimeo: {
            apiLogin: false,
            enabled: false

        }
    }
];

export const RECORDING_TOOLS = [
    {
        DropBox: {
            apiLogin: false,
            enabled: true


        },
        enabled: true,
        icon: 'IconRec',
        title: 'DropBox Recording',
        toggle: false


    },
    {
        OneDrive: {
            apiLogin: false,
            enabled: true


        },
        enabled: true,
        icon: 'IconRec',
        title: 'OneDrive Recording',
        toggle: false


    }
];


